export default "__VITE_ASSET__BogF0och__"